import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f63c45ae&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f63c45ae')) {
      api.createRecord('f63c45ae', component.options)
    } else {
      api.reload('f63c45ae', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f63c45ae&", function () {
      api.rerender('f63c45ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MoLBS243NdfA/JS/comp/ImgFallback.vue"
export default component.exports